import React, { PropTypes, Component } from 'react'

export class SidebarPartnerPlanNav extends Component {
  static propTypes = {
    partnerPlanSideNav: PropTypes.obj,
  }
  static defaultProps = {
    partnerPlanSideNav: {},
  }

  render() {
    const showPartnerPlanLinks = window.location.href.includes('/partnerplans/myplans')
    const { partnerPlanSideNav } = this.props
    if (partnerPlanSideNav && partnerPlanSideNav.length > 0 && showPartnerPlanLinks) {
      // eslint-disable-next-line react/no-danger
      return (<p dangerouslySetInnerHTML={{ __html: partnerPlanSideNav }} />)
    }
    return (<div />)
  }
}

export default SidebarPartnerPlanNav



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/components/Sidebar/SidebarNav.js